import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import App from "@/src/App.vue";
import router from "@/src/router/index.ts";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { createClientConfig } from "@/src/config/client";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import ko from "element-plus/es/locale/lang/ko";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "vue-loading-overlay/dist/css/index.css";
import "@/src/assets/css/main.scss";
import VueDaumPostcode from "vue-daum-postcode";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      refetchOnWindowFocus: false,
      retry: 0,
    },
    mutations: {
      retry: 0,
    },
  },
});

const store = createPinia();
store.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(VueQueryPlugin, {
  queryClient,
});
app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: ko,
});
app.mount("#app");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(VueDaumPostcode)

// API 클라이언트 설정 초기화
createClientConfig({});
